import React from "react";

import "./WithdrawalSection.scss";
import Icon from '../Icon/Icon';
import { useDraggableSheet } from "../../../helpers/hooks";

function WithdrawalSuccess({ onClose }) {
    const { sheetStyle, overlayHandlers } = useDraggableSheet({ onClose });

    return (
        <div className="withdrawal-section" {...overlayHandlers}>
            <div
                className={`sheet`}
                style={sheetStyle}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="pull-bar" />

                <div className="withdrawal-box px-24">
                    <div className="success-box d-flex f-column my-48 aic jcc">
                        <div className=" red-circle mt-48">
                            { <Icon
                                alias="withdrawal_confirmed"
                                width={200}
                                height={200}
                                color="#ff0000"
                            /> }
                        </div>
                        <h3 className="title mb-12 mt-32">Money on the way</h3>
                        <p className="description mt-0">
                            You should see the amount in your bank account soon
                        </p>
                    </div>
                </div>

                <div className="submit-box d-flex f-column px-16 py-24">
                    <button
                        onClick={onClose}
                        type="button"
                        className="btn red-outline-btn btn-full d-flex aic jcc fw-bold py-24 mb-24"
                    >
                        <span>Close</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WithdrawalSuccess;
